import React from 'react';

interface Stat {
  label: string;
  value: string;
  color?: string;
}

export const StatsGrid: React.FC<{ stats: Stat[] }> = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6 mb-8">
    {stats.map((s, i) => (
      <div key={i} className="bg-[#0d1117] border border-white/8 rounded-xl p-4">
        <p className="text-[10px] uppercase tracking-wider text-gray-500 font-bold">{s.label}</p>
        <p className={`text-2xl font-bold mt-1 ${s.color || 'text-gray-100'}`}>{s.value}</p>
      </div>
    ))}
  </div>
);
